<template>
    <div>
        <h1 style="font-size: 24px; color: black;">角色管理</h1>
        <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="showAddFormDialog('新增角色')">添加角色</el-button>
        </div>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="addFormDialogVisible" center >
                <el-form :model="addForm">
                    <el-form-item label="角色名称" :label-width="labelWidth">
                        <el-input type="text" v-model="addForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="权限字符串" :label-width="labelWidth">
                        <el-input type="text" v-model="addForm.permission"></el-input>
                    </el-form-item>
                    <el-form-item label="权限" :label-width="labelWidth">
                        <tree-transfer
                            :title="treeTitle"
                            :pid="parentId"
                            :from_data='fromData'
                            :to_data='toData'  
                            :defaultProps="{label:'name'}" 
                            @add-btn='add'                
                            @remove-btn='remove'            
                            :mode='mode'     
                            height='400px'   >
                        </tree-transfer> 
                    </el-form-item> 
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddFormDialog">确 定</el-button>
                        <el-button type="info" @click="closeAddFormDialog">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <div>
            <el-table
                    border
                    :data="roles">
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="name" label="角色名称"></el-table-column>
                <el-table-column prop="permission" label="权限字符串"></el-table-column>
                <el-table-column prop="updateDt" :formatter="formatDate" label="更新时间"></el-table-column>
                <el-table-column prop="createDt" :formatter="formatDate" label="创建时间"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini"
                                   type="primary"
                                   @click="showAddFormDialog('修改角色信息', scope.row)">编辑</el-button>
                        <el-button size="mini"
                                   type="danger"
                                   @click="handelDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import treeTransfer from 'el-tree-transfer' // 引入
    import {
        allRoles,
        saveRole,
        deleteRole,
        allPermissions,
        userPermission
    } from "@/http/api";
    import utils from '@/utils'

    export default {
        inject:['reload'],
        name: "RoleList",
        components:{treeTransfer},
        data () {
            return {
                addForm: {
                    id:null,
                    name: null,
                    permission:null,
                    permissionTree:[]
                },
                dialogTitle: '',
                labelWidth: '100px',
                addFormDialogVisible: false,
                roles: [
                ],
                permissions:[],
                fromData:[],
                toData:[],
                mode: "transfer",
                parentId: "parentId",
                treeTitle:["全部权限","已选权限"] 
            }
        },
        methods: {
            formatDate: function(row, column, cellValue) {
                return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
            },
            handelDelete(id){
                this.$confirm('确认是否删除?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteRole(id).then(resp=>{
                        if (resp.data.status==0){
                            this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                            this.reload();
                        }else{
                            this.$message({
                                message: "操作失败",
                                type: 'error'
                            });
                        }
                    });
                })
            },
            showAddFormDialog (_title, _data) {
                //深拷贝数组
                this.fromData =  this.permissions.slice(0);
                this.toData=[];
                this.dialogTitle = _title
                this.addForm = {
                    id:null,
                    name: null,
                    permission:null,
                    permissionTree:[]
                }
                if(_data){
                    this.addForm.id = _data.id;
                    this.addForm.name = _data.name;
                    this.addForm.permission = _data.permission;
                    userPermission(_data.id).then(resp=>{
                       this.toData=resp.data.info;
                    });
                }
                this.addFormDialogVisible = true
            },
            closeAddFormDialog () {
                this.addFormDialogVisible = false
            },
            confirmAddFormDialog(){
                this.addForm.permissionTree=this.toData;
                saveRole(this.addForm).then(resp=>{
                    if (resp.data.status==0){
                        this.$message({
                            message: "操作成功",
                            type: 'success'
                        });
                        this.reload();
                    }else{
                        this.$message({
                            message: "操作失败",
                            type: 'error'
                        });
                    }
                });
            },
            add(fromData,toData,obj){
            // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
            console.log("fromData:", fromData);
            console.log("toData:", toData);
            console.log("obj:", obj);
          },
          // 监听穿梭框组件移除
          remove(fromData,toData,obj){
            // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
            console.log("fromData:", fromData);
            console.log("toData:", toData);
            console.log("obj:", obj);
          },
        },
        created () {
            allRoles().then(resp=>{
                this.roles = resp.data.info;
            })
            allPermissions().then(resp=>{
                var permissionsBeofre= resp.data.info;
                this.permissions = permissionsBeofre;
            })
        }
    }
</script>

<style scoped>

</style>
